import { useState,useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";



import { Outlet, Link, useLocation } from 'react-router-dom';
import ProfileHeader from "../page_components/notarial_book/profile_header";
import useFetch from "../hooks/useFetch";


const NotarialBook = () => {
  const { user,location,errorLocation } = useAuth();
  console.log(user);

  const [activeTab, setActiveTab] = useState('');
  const pagelocation = useLocation();

  useEffect(() => {
    if (pagelocation.pathname.startsWith('/notarialbook/settings')) {
      setActiveTab('settings');
    } else if (pagelocation.pathname.startsWith('/notarialbook/transactions')) {
      setActiveTab('transactions');
    } else if (pagelocation.pathname.startsWith('/notarialbook/lawyers')) {
      setActiveTab('lawyers');
    } else {
      setActiveTab('');
    }
  }, [pagelocation.pathname]);

  const {
    data,
    isLoading,
    errorMessage,
  } = useFetch(`${process.env.REACT_APP_API_URL}/profile/`);


  // if (isLoading) return <p>Loading profile...</p>;
  // if (errorMessage) return <p>Error: {errorMessage}</p>;

  

    return (

      <div>

        <div className="container-xxl flex-grow-1 container-p-y">
          <h4 className="py-3 mb-4">
            <span className="text-muted fw-light">Notarial Book /</span> {activeTab[0]?.toUpperCase()+activeTab?.slice(1).toLowerCase()}
          </h4>
          <ProfileHeader activeTab={activeTab} details={data} />
          <div className="row">
            <div className="col-md-12">
              <ul className="nav nav-pills flex-column flex-sm-row mb-4">
                <li className="nav-item">
              
                  <Link to="/notarialbook/transactions?page=1" className={`nav-link ${activeTab === 'transactions' && 'active'}`}  onClick={() => setActiveTab('transactions')} >
                        <i className="bx bx-data me-1" />
                        <div>Transactions</div>
                    </Link>
                </li>
                

                {user.user_type.toUpperCase() === 'ADMIN' && 
                 <li className="nav-item">
                    <Link to="/notarialbook/lawyers?page=1" className={`nav-link ${activeTab === 'lawyers' && 'active'}`}  onClick={() => setActiveTab('lawyers')} >
                        <i className="bx bx-group me-1" />
                        <div>Lawyers</div>
                    </Link>
                </li>
                }
              
                <li className="nav-item">
                    <Link to="/notarialbook/settings" className={`nav-link ${activeTab === 'settings' && 'active'}`}  onClick={() => setActiveTab('settings')} >
                        <i className="bx bx-cog me-1" />
                        <div>Account Settings</div>
                    </Link>
                </li>

              
              </ul>


            </div>
          </div>
          <div className="row">
             <Outlet context={{ details:data, isLoading }} />
          </div>
        </div>


      </div>


       
    );
}

export default NotarialBook;